import { FunctionComponent, memo } from "react";
import { IProps } from "./interaction-options-menu.types";
import { EllipsisMenu } from "@edgetier/client-components";
import CopyUrlLink from "../copy-url-link";
import ExternalInteractionLink from "../external-interaction-link";
import FullScreenLink from "../full-screen-link";
import ToggleHighlightWritingIssues from "../toggle-highlight-writing-issues";
import DownloadInteractionPdf from "../download-interaction-pdf";
import "./interaction-options-menu.scss";

/**
 * A menu with several options for actions that the user can take relating to the interaction.
 * @param props.interactionId        The ID of the interaction.
 * @param props.interactionUrl       The URL of the external interaction.
 * @param props.showFullScreenOption A boolean indicating if the fullscreen option should be shown.
 */
const InteractionOptionsMenu: FunctionComponent<IProps> = ({
    interactionId,
    interactionUrl,
    showFullScreenOption = true,
}) => (
    <EllipsisMenu
        isButton
        isVerticalEllipsis
        menuLabel="Options"
        overflowContainer
        placement={showFullScreenOption ? "left-start" : "bottom-center"}
    >
        {showFullScreenOption && <FullScreenLink interactionId={interactionId} />}
        <CopyUrlLink interactionId={interactionId} />
        <DownloadInteractionPdf interactionId={interactionId} />
        <ExternalInteractionLink interactionId={interactionId} url={interactionUrl} />
        <ToggleHighlightWritingIssues />
    </EllipsisMenu>
);

export default memo(InteractionOptionsMenu);
